<div id="financialServiceViewMobile" *ngIf="financialService">
  <h3>Servicio financiero</h3>
  <div>
    <!-- Incluir clase "simple", "conSucursal" o "conDistribuidor" en el div.wrapper según corresponda -->
    <div class="wrapper">
      <div class="companiaYNumero">
        <div>
          <label>Compañía</label> <span class="value">{{ financialService.companyName }}</span>
        </div>
        <div *ngIf="financialService.id" class="controlWrapper">
          <label>Número</label>
          <span class="value">{{ financialService.id }}</span>
        </div>
      </div>

      <div class="controlWrapper">
        <label>Distribuidor</label
        ><span class="value"> <app-label-dealer [dealerId]="dealerId"></app-label-dealer></span>
      </div>

      <div class="controlWrapper">
        <label>Sucursal</label
        ><span class="value">
          {{ dealerBranchName ? dealerBranchName : 'No se encuentra sucursal' }}
        </span>
      </div>

      <div class="controlWrapper">
        <label>Nombre de la cotización</label>
        <span class="value">{{ financialService.quoteName }}</span>
      </div>
    </div>
  </div>
</div>
